<button type="button" aria-label="Close" class="mui-toast__close" *ngIf="options.closeButton && !options.tapToDismiss" (click)="remove()">
  <mui-icon font="fa" name="times"></mui-icon>
</button>
<div class="mui-toast__internal-wrapper">
  <div class="mui-toast__icon" *ngIf="options.icon">
    <mui-icon [font]="options.iconFont || 'fa'" [iconStyle]="options.iconStyle" [name]="options.icon"></mui-icon>
  </div>
  <div class="mui-toast__content">
    <h5 *ngIf="title" class="mui-toast__title" [attr.aria-label]="title" [id]="labelId">
      {{ title }}
    </h5>
    <p
      class="mui-toast__message"
      [ngClass]="{
        'mui-toast--success': isSuccessToast,
        'mui-toast--warning': isWarningToast,
        'mui-toast--danger': isDangerToast,
        'mui-toast--info': isInfoToast
      }"
      *ngIf="message && options.enableHtml"
      [id]="labelId+'-desc'"
      [innerHTML]="message"></p>
    <p
      class="mui-toast__message"
      [ngClass]="{
        'mui-toast--success': isSuccessToast,
        'mui-toast--warning': isWarningToast,
        'mui-toast--danger': isDangerToast,
        'mui-toast--info': isInfoToast

      }"
      *ngIf="message && !options.enableHtml"
      [id]="labelId+'-desc'">
      {{ message }}
    </p>
    <div class="mui-toast__action-container" *ngIf="options.hasAction">
      <button mui-btn appearance="secondary" size="small" (click)="action($event)" class="mui-toast__action">
        {{ options.actionText || 'Action' }}
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="options.progressBar"
  role="presentation"
  class="mui-toast__progress"
  [style.width]="width + '%'"></div>
